export const ROUTES = {
  HOME: '/*',
  HOME_CHILD: '/',

  ERROR_404: "*/*",
}
